import { render, staticRenderFns } from "./PrivateDiscussionLinkedin.vue?vue&type=template&id=6c1b8a5d"
import script from "./PrivateDiscussionLinkedin.vue?vue&type=script&lang=js"
export * from "./PrivateDiscussionLinkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1b8a5d')) {
      api.createRecord('6c1b8a5d', component.options)
    } else {
      api.reload('6c1b8a5d', component.options)
    }
    module.hot.accept("./PrivateDiscussionLinkedin.vue?vue&type=template&id=6c1b8a5d", function () {
      api.rerender('6c1b8a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/PrivateDiscussionLinkedin.vue"
export default component.exports